/* Single source of truth for Orchid Hotels branding. */
export const ORCHID_LOGO =
    "https://customer-assets.emergentagent.com/job_beautiful-gagarin-9/artifacts/b4owmkgs_IMG-20260527-WA0000.jpg";

/* Priya — the concierge bot's identity + AI avatar icon. */
export const PRIYA_NAME = "Priya";
export const PRIYA_AVATAR = "/api/widget/avatar/priya";

export const BRAND = {
    name: "The Orchid Hotels",
    tagline: "",
    fullTagline: "Asia's First Eco-Luxury Hotel Chain — Since 1986",
    /* Primary purple (from "ORCHID" wordmark) */
    primary: "#7E2A6C",
    primaryDark: "#581849",
    primaryDarker: "#43113A",
    /* Secondary sage green (from "THE" and "FIVE STAR ECOTEL HOTEL") */
    secondary: "#536F55",
    secondaryDark: "#2F4232",
    /* Accent */
    gold: "#D4AF37",
    cream: "#FAF7F1",
};
